export default __webpack_public_path__ + "static/media/documentar-icon.d7e3dc6f.svg";